import styled from "styled-components";

export const StyledSection = styled.section`
    height: 100vh;
    width: 100%;
    background-image: url(${props => props.bgImage});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: left center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 0;
    }
    @media (max-width: 1024px) {
        justify-content: center;
    }
`;

export const StyledMain = styled.main`
    background-color: #fff;
    height: 100vh;
    max-width: 767px;
    width: 100%;
    position: relative;
    @media (max-width: 1024px) {
        height: 49vh;
        max-width: 540px;
    }
    @media (max-width: 540px) {
        height: 94%;
        max-width: 90%;
    }
    @media (max-height: 800px) {
        height: 94%;
    }
`